<template>
  <v-container fluid class="px-1 py-1">
    <CommonTable
        title="RequestRawList"
        :embedded="embedded"
        :height="height"
        :dto-list-query="dtoListQuery"
        :dto-detail-query="dtoDetailQuery"
        :dto-action-command="dtoActionCommand"
        :store-name="storeName"
        :detail-store-name="detailStoreName"
        detailComponentPass="/Panasonic/RequestRawDetail"
        :parent-component="$options.name"
        @embedded_close="$emit('embedded_close')"
    >
      <template v-slot:item.request="{ item }">
        <v-sheet class="overflow-y-auto overflow-x-auto my-3"
            height="100"
        >
          {{ item.request }}
        </v-sheet>
      </template>
      <template v-slot:item.response="{ item }">
        <v-sheet class="overflow-y-auto overflow-x-auto my-3"
            height="100"
        >
          {{ item.response }}
        </v-sheet>
      </template>
      <template v-slot:item.error_message="{ item }">
        <v-sheet class="overflow-y-auto overflow-x-auto my-3"
            height="100"
        >
          {{ item.error_message }}
        </v-sheet>
      </template>
    </CommonTable>
  </v-container>
</template>

<script>
import {useAggregateStore} from '@/store/CommonStore/baseAggregateStore'
import {useTableStore} from "@/components/Common/CommonTable";
import CommonTable from "@/components/Common/CommonTable";
import RequestRawDetail from "@/components/Panasonic/RequestRawDetail";

export default {
  name: "RequestRawTable",

  props: {
    embedded: {default: false},
    height: {default: null},
    storeName: {type: [String], default: 'RequestRawTable'},
    dtoDetailQuery: {default: 'RequestRawDetailQueryDTO'},
    detailStoreName: {default: 'RequestRawDetail'},
    dtoValidateCommand: {type: [String], default: 'RequestRawValidateCommandDTO'},
    dtoListQuery: {type: [String], default: 'RequestRawListQueryDTO'},
    dtoActionCommand: {type: [String], default: 'RequestRawActionCommandDTO'},
    dtoSaveCommand: {type: [String], default: 'RequestRawSaveCommandDTO'},
    mainValidator: {type: [Boolean], default: false},
  },

  components: {
    CommonTable,
    RequestRawDetail,
  },

  methods: {
  },


  mounted() {
    this.storeTable = useTableStore(this.storeName)()
    this.storeTable.headers = [
      {text: 'E', value: 'edit', sortable: false, filterable: true, divider: true, width: 30},
      {text: 'Request type', value: 'request_type', sortable: true, filterable: true, divider: true, width: 100},
      {text: 'Endpoint', value: 'endpoint', sortable: true, filterable: true, divider: true, width: 100},
      {text: 'Remote address', value: 'remote_address', sortable: true, filterable: true, divider: true, width: 100},
      {text: 'Name DTO', value: 'name_dto', sortable: true, filterable: true, divider: true, width: 100},
      {text: 'Request', value: 'request', sortable: true, filterable: true, divider: true, width: 600},
      {text: 'Response', value: 'response', sortable: true, filterable: true, divider: true, width: 300},
      {text: 'Error message', value: 'error_message', sortable: true, filterable: true, divider: true, width: 200},
      {text: 'edited_by', value: 'edited_by_uid', sortable: true, filterable: true, divider: true},
      {text: 'edited_on', value: 'edited_on', sortable: true, filterable: true, divider: true, type: 'datetime_long'},
      {text: 'created_by', value: 'created_by_uid', sortable: true, filterable: true, divider: true},
      {text: 'created_on', value: 'created_on', sortable: true, filterable: true, divider: true, type: 'datetime_long'},
      {text: '', value: 'is_saved', sortable: false, filterable: true, divider: true, width: 30},
    ]
    this.storeAggregate = useAggregateStore()
    if (!!this.storeTable) {
      this.storeTable.dtoDetailQuery = this.dtoDetailQuery
      this.storeTable.dtoListQuery = this.dtoListQuery
      this.storeTable.dtoActionCommand = this.dtoActionCommand
      this.storeTable.dtoSaveCommand = this.dtoSaveCommand
      this.storeTable.options.sortBy = ['created_on']
    }
  },

  data() {
    return {
      storeTable: null,
    }
  },
}
</script>

<style scoped>

</style>